"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function enableInboxRuleRequest(data) {
    var result = tslib_1.__assign({ __type: 'EnableInboxRuleRequest:#Exchange' }, data);
    return result;
}
exports.default = enableInboxRuleRequest;
